import { useState } from 'react';
import { useIntl } from 'react-intl';
import ApiErrorAlert from 'src/components/_common/ApiErrorAlert/ApiErrorAlert';
import PageHeader from 'src/components/_common/PageHeader/PageHeader';
import Spinner from 'src/components/_common/Spinner/Spinner';
import useLoggedInUser from 'src/hooks/user/useLoggedInUser';
import InvitationForm from './InvitationForm';
import QrInvitation from './QrInvitation';
import SupervisorBadge from './SupervisorBadge';

type InvitationMode = 'email' | 'qr';

export default function InviteSupervisorPage() {
  const { formatMessage } = useIntl();
  const loggedInUserQuery = useLoggedInUser();
  const [mode, setMode] = useState<InvitationMode>('email');

  if (loggedInUserQuery.isLoading) return <Spinner />;
  if (loggedInUserQuery.isError) return <ApiErrorAlert error={loggedInUserQuery.error} message={formatMessage({ id: 'inviteSupervisorPageErrorMessage' })} />;

  const supervisorId = loggedInUserQuery.data.studentReferences?.advisorUserId;

  return (
    <>
      <PageHeader
        title={formatMessage({ id: 'inviteSupervisorPageTitle' })}
        subTitle={formatMessage({ id: 'inviteSupervisorPageSubTitle' })}
      />

      {supervisorId && <SupervisorBadge id={supervisorId} />}

      {mode === 'email' && (
        <>
          <InvitationForm supervisorExists={!!supervisorId} />
          <div className="flex justify-center mt-4">
            <button type="button" className="underline" data-testid="invite-supervisor-show-qr-button" onClick={() => setMode('qr')}>
              {formatMessage({ id: 'inviteSupervisorQrToggleToQr' })}
            </button>
          </div>
        </>
      )}

      {mode === 'qr' && <QrInvitation onBack={() => setMode('email')} />}
    </>
  );
}
